// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AchievementsRouteImport } from './routes/achievements'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BasicSupportRouteImport } from './routes/basic-support'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as F1VisaInterviewQuestionsRouteImport } from './routes/f1-visa-interview-questions'
import { Route as FindYourPlanRouteImport } from './routes/find-your-plan'
import { Route as FreevisasessionsRouteImport } from './routes/freevisasessions'
import { Route as FullSupportRouteImport } from './routes/full-support'
import { Route as InterviewexperiencesRouteImport } from './routes/interviewexperiences'
import { Route as PaymentSuccessRouteImport } from './routes/payment-success'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as RefusalCaseStudyRouteImport } from './routes/refusal-case-study'
import { Route as RefusalDecoderRouteImport } from './routes/refusal-decoder'
import { Route as RefusalSupportRouteImport } from './routes/refusal-support'
import { Route as RefusalVictoriesRouteImport } from './routes/refusal-victories'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as ShippingDeliveryRouteImport } from './routes/shipping-delivery'
import { Route as StudentDashboardRouteImport } from './routes/student-dashboard'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as UsVisaSchedulingGuideRouteImport } from './routes/us-visa-scheduling-guide'
import { Route as VisaReadinessRouteImport } from './routes/visa-readiness'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminAccessRouteImport } from './routes/admin.access'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as AdminBroadcastRouteImport } from './routes/admin.broadcast'
import { Route as AdminCalendarRouteImport } from './routes/admin.calendar'
import { Route as AdminChangesRouteImport } from './routes/admin.changes'
import { Route as AdminDs160RouteImport } from './routes/admin.ds160'
import { Route as AdminInboxRouteImport } from './routes/admin.inbox'
import { Route as AdminIncompleteCheckoutsRouteImport } from './routes/admin.incomplete-checkouts'
import { Route as AdminIntakeRouteImport } from './routes/admin.intake'
import { Route as AdminInterviewPriorityRouteImport } from './routes/admin.interview-priority'
import { Route as AdminInterviewTrackRouteImport } from './routes/admin.interview-track'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminLiveSessionsRouteImport } from './routes/admin.live-sessions'
import { Route as AdminLogsRouteImport } from './routes/admin.logs'
import { Route as AdminMeetingsRouteImport } from './routes/admin.meetings'
import { Route as AdminMockSchedulingRouteImport } from './routes/admin.mock-scheduling'
import { Route as AdminMonthlyEnrollmentsRouteImport } from './routes/admin.monthly-enrollments'
import { Route as AdminPaymentsRouteImport } from './routes/admin.payments'
import { Route as AdminPendingPaymentsRouteImport } from './routes/admin.pending-payments'
import { Route as AdminSessionsRouteImport } from './routes/admin.sessions'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminSignupsRouteImport } from './routes/admin.signups'
import { Route as AdminSocialPreviewRouteImport } from './routes/admin.social-preview'
import { Route as AdminStudentsRouteImport } from './routes/admin.students'
import { Route as AdminTestingRouteImport } from './routes/admin.testing'
import { Route as AdminUnsubscribeRouteImport } from './routes/admin.unsubscribe'
import { Route as AdminUploadExperienceRouteImport } from './routes/admin.upload-experience'
import { Route as AdminVisaAssessmentsRouteImport } from './routes/admin.visa-assessments'
import { Route as AdminVisaTestersRouteImport } from './routes/admin.visa-testers'
import { Route as ReceiptIdRouteImport } from './routes/receipt.$id'
import { Route as ResourcesIndexRouteImport } from './routes/resources.index'
import { Route as ResourcesSlugRouteImport } from './routes/resources.$slug'
import { Route as ResourcesF1VisaGuideRouteImport } from './routes/resources.f1-visa-guide'
import { Route as ResourcesFresherGuideRouteImport } from './routes/resources.fresher-guide'
import { Route as VisaReadinessIndexRouteImport } from './routes/visa-readiness.index'
import { Route as VisaReadinessAssessmentRouteImport } from './routes/visa-readiness.assessment'
import { Route as AdminCohortsFall2026RouteImport } from './routes/admin.cohorts.fall-2026'
import { Route as AdminCohortsFall2027RouteImport } from './routes/admin.cohorts.fall-2027'
import { Route as AdminCohortsSpring2027RouteImport } from './routes/admin.cohorts.spring-2027'
import { Route as VisaReadinessReportIdRouteImport } from './routes/visa-readiness.report.$id'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AchievementsRoute = AchievementsRouteImport.update({
            id: '/achievements',path: '/achievements',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BasicSupportRoute = BasicSupportRouteImport.update({
            id: '/basic-support',path: '/basic-support',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const F1VisaInterviewQuestionsRoute = F1VisaInterviewQuestionsRouteImport.update({
            id: '/f1-visa-interview-questions',path: '/f1-visa-interview-questions',getParentRoute: () => rootRouteImport
          })
const FindYourPlanRoute = FindYourPlanRouteImport.update({
            id: '/find-your-plan',path: '/find-your-plan',getParentRoute: () => rootRouteImport
          })
const FreevisasessionsRoute = FreevisasessionsRouteImport.update({
            id: '/freevisasessions',path: '/freevisasessions',getParentRoute: () => rootRouteImport
          })
const FullSupportRoute = FullSupportRouteImport.update({
            id: '/full-support',path: '/full-support',getParentRoute: () => rootRouteImport
          })
const InterviewexperiencesRoute = InterviewexperiencesRouteImport.update({
            id: '/interviewexperiences',path: '/interviewexperiences',getParentRoute: () => rootRouteImport
          })
const PaymentSuccessRoute = PaymentSuccessRouteImport.update({
            id: '/payment-success',path: '/payment-success',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RefundRoute = RefundRouteImport.update({
            id: '/refund',path: '/refund',getParentRoute: () => rootRouteImport
          })
const RefusalCaseStudyRoute = RefusalCaseStudyRouteImport.update({
            id: '/refusal-case-study',path: '/refusal-case-study',getParentRoute: () => rootRouteImport
          })
const RefusalDecoderRoute = RefusalDecoderRouteImport.update({
            id: '/refusal-decoder',path: '/refusal-decoder',getParentRoute: () => rootRouteImport
          })
const RefusalSupportRoute = RefusalSupportRouteImport.update({
            id: '/refusal-support',path: '/refusal-support',getParentRoute: () => rootRouteImport
          })
const RefusalVictoriesRoute = RefusalVictoriesRouteImport.update({
            id: '/refusal-victories',path: '/refusal-victories',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const ShippingDeliveryRoute = ShippingDeliveryRouteImport.update({
            id: '/shipping-delivery',path: '/shipping-delivery',getParentRoute: () => rootRouteImport
          })
const StudentDashboardRoute = StudentDashboardRouteImport.update({
            id: '/student-dashboard',path: '/student-dashboard',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const UsVisaSchedulingGuideRoute = UsVisaSchedulingGuideRouteImport.update({
            id: '/us-visa-scheduling-guide',path: '/us-visa-scheduling-guide',getParentRoute: () => rootRouteImport
          })
const VisaReadinessRoute = VisaReadinessRouteImport.update({
            id: '/visa-readiness',path: '/visa-readiness',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const AdminAccessRoute = AdminAccessRouteImport.update({
            id: '/admin/access',path: '/admin/access',getParentRoute: () => rootRouteImport
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/admin/analytics',path: '/admin/analytics',getParentRoute: () => rootRouteImport
          })
const AdminBroadcastRoute = AdminBroadcastRouteImport.update({
            id: '/admin/broadcast',path: '/admin/broadcast',getParentRoute: () => rootRouteImport
          })
const AdminCalendarRoute = AdminCalendarRouteImport.update({
            id: '/admin/calendar',path: '/admin/calendar',getParentRoute: () => rootRouteImport
          })
const AdminChangesRoute = AdminChangesRouteImport.update({
            id: '/admin/changes',path: '/admin/changes',getParentRoute: () => rootRouteImport
          })
const AdminDs160Route = AdminDs160RouteImport.update({
            id: '/admin/ds160',path: '/admin/ds160',getParentRoute: () => rootRouteImport
          })
const AdminInboxRoute = AdminInboxRouteImport.update({
            id: '/admin/inbox',path: '/admin/inbox',getParentRoute: () => rootRouteImport
          })
const AdminIncompleteCheckoutsRoute = AdminIncompleteCheckoutsRouteImport.update({
            id: '/admin/incomplete-checkouts',path: '/admin/incomplete-checkouts',getParentRoute: () => rootRouteImport
          })
const AdminIntakeRoute = AdminIntakeRouteImport.update({
            id: '/admin/intake',path: '/admin/intake',getParentRoute: () => rootRouteImport
          })
const AdminInterviewPriorityRoute = AdminInterviewPriorityRouteImport.update({
            id: '/admin/interview-priority',path: '/admin/interview-priority',getParentRoute: () => rootRouteImport
          })
const AdminInterviewTrackRoute = AdminInterviewTrackRouteImport.update({
            id: '/admin/interview-track',path: '/admin/interview-track',getParentRoute: () => rootRouteImport
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/admin/leads',path: '/admin/leads',getParentRoute: () => rootRouteImport
          })
const AdminLiveSessionsRoute = AdminLiveSessionsRouteImport.update({
            id: '/admin/live-sessions',path: '/admin/live-sessions',getParentRoute: () => rootRouteImport
          })
const AdminLogsRoute = AdminLogsRouteImport.update({
            id: '/admin/logs',path: '/admin/logs',getParentRoute: () => rootRouteImport
          })
const AdminMeetingsRoute = AdminMeetingsRouteImport.update({
            id: '/admin/meetings',path: '/admin/meetings',getParentRoute: () => rootRouteImport
          })
const AdminMockSchedulingRoute = AdminMockSchedulingRouteImport.update({
            id: '/admin/mock-scheduling',path: '/admin/mock-scheduling',getParentRoute: () => rootRouteImport
          })
const AdminMonthlyEnrollmentsRoute = AdminMonthlyEnrollmentsRouteImport.update({
            id: '/admin/monthly-enrollments',path: '/admin/monthly-enrollments',getParentRoute: () => rootRouteImport
          })
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
            id: '/admin/payments',path: '/admin/payments',getParentRoute: () => rootRouteImport
          })
const AdminPendingPaymentsRoute = AdminPendingPaymentsRouteImport.update({
            id: '/admin/pending-payments',path: '/admin/pending-payments',getParentRoute: () => rootRouteImport
          })
const AdminSessionsRoute = AdminSessionsRouteImport.update({
            id: '/admin/sessions',path: '/admin/sessions',getParentRoute: () => rootRouteImport
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/admin/settings',path: '/admin/settings',getParentRoute: () => rootRouteImport
          })
const AdminSignupsRoute = AdminSignupsRouteImport.update({
            id: '/admin/signups',path: '/admin/signups',getParentRoute: () => rootRouteImport
          })
const AdminSocialPreviewRoute = AdminSocialPreviewRouteImport.update({
            id: '/admin/social-preview',path: '/admin/social-preview',getParentRoute: () => rootRouteImport
          })
const AdminStudentsRoute = AdminStudentsRouteImport.update({
            id: '/admin/students',path: '/admin/students',getParentRoute: () => rootRouteImport
          })
const AdminTestingRoute = AdminTestingRouteImport.update({
            id: '/admin/testing',path: '/admin/testing',getParentRoute: () => rootRouteImport
          })
const AdminUnsubscribeRoute = AdminUnsubscribeRouteImport.update({
            id: '/admin/unsubscribe',path: '/admin/unsubscribe',getParentRoute: () => rootRouteImport
          })
const AdminUploadExperienceRoute = AdminUploadExperienceRouteImport.update({
            id: '/admin/upload-experience',path: '/admin/upload-experience',getParentRoute: () => rootRouteImport
          })
const AdminVisaAssessmentsRoute = AdminVisaAssessmentsRouteImport.update({
            id: '/admin/visa-assessments',path: '/admin/visa-assessments',getParentRoute: () => rootRouteImport
          })
const AdminVisaTestersRoute = AdminVisaTestersRouteImport.update({
            id: '/admin/visa-testers',path: '/admin/visa-testers',getParentRoute: () => rootRouteImport
          })
const ReceiptIdRoute = ReceiptIdRouteImport.update({
            id: '/receipt/$id',path: '/receipt/$id',getParentRoute: () => rootRouteImport
          })
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
            id: '/resources/',path: '/resources/',getParentRoute: () => rootRouteImport
          })
const ResourcesSlugRoute = ResourcesSlugRouteImport.update({
            id: '/resources/$slug',path: '/resources/$slug',getParentRoute: () => rootRouteImport
          })
const ResourcesF1VisaGuideRoute = ResourcesF1VisaGuideRouteImport.update({
            id: '/resources/f1-visa-guide',path: '/resources/f1-visa-guide',getParentRoute: () => rootRouteImport
          })
const ResourcesFresherGuideRoute = ResourcesFresherGuideRouteImport.update({
            id: '/resources/fresher-guide',path: '/resources/fresher-guide',getParentRoute: () => rootRouteImport
          })
const VisaReadinessIndexRoute = VisaReadinessIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => VisaReadinessRoute
          })
const VisaReadinessAssessmentRoute = VisaReadinessAssessmentRouteImport.update({
            id: '/assessment',path: '/assessment',getParentRoute: () => VisaReadinessRoute
          })
const AdminCohortsFall2026Route = AdminCohortsFall2026RouteImport.update({
            id: '/admin/cohorts/fall-2026',path: '/admin/cohorts/fall-2026',getParentRoute: () => rootRouteImport
          })
const AdminCohortsFall2027Route = AdminCohortsFall2027RouteImport.update({
            id: '/admin/cohorts/fall-2027',path: '/admin/cohorts/fall-2027',getParentRoute: () => rootRouteImport
          })
const AdminCohortsSpring2027Route = AdminCohortsSpring2027RouteImport.update({
            id: '/admin/cohorts/spring-2027',path: '/admin/cohorts/spring-2027',getParentRoute: () => rootRouteImport
          })
const VisaReadinessReportIdRoute = VisaReadinessReportIdRouteImport.update({
            id: '/report/$id',path: '/report/$id',getParentRoute: () => VisaReadinessRoute
          })





const VisaReadinessRouteChildren = {
  VisaReadinessAssessmentRoute: VisaReadinessAssessmentRoute,VisaReadinessIndexRoute: VisaReadinessIndexRoute,VisaReadinessReportIdRoute: VisaReadinessReportIdRoute
}

const VisaReadinessRouteWithChildren = VisaReadinessRoute._addFileChildren(VisaReadinessRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AchievementsRoute: AchievementsRoute,AuthRoute: AuthRoute,BasicSupportRoute: BasicSupportRoute,ContactRoute: ContactRoute,F1VisaInterviewQuestionsRoute: F1VisaInterviewQuestionsRoute,FindYourPlanRoute: FindYourPlanRoute,FreevisasessionsRoute: FreevisasessionsRoute,FullSupportRoute: FullSupportRoute,InterviewexperiencesRoute: InterviewexperiencesRoute,PaymentSuccessRoute: PaymentSuccessRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RefundRoute: RefundRoute,RefusalCaseStudyRoute: RefusalCaseStudyRoute,RefusalDecoderRoute: RefusalDecoderRoute,RefusalSupportRoute: RefusalSupportRoute,RefusalVictoriesRoute: RefusalVictoriesRoute,ServicesRoute: ServicesRoute,ShippingDeliveryRoute: ShippingDeliveryRoute,StudentDashboardRoute: StudentDashboardRoute,TermsRoute: TermsRoute,UsVisaSchedulingGuideRoute: UsVisaSchedulingGuideRoute,VisaReadinessRoute: VisaReadinessRouteWithChildren,AdminAccessRoute: AdminAccessRoute,AdminAnalyticsRoute: AdminAnalyticsRoute,AdminBroadcastRoute: AdminBroadcastRoute,AdminCalendarRoute: AdminCalendarRoute,AdminChangesRoute: AdminChangesRoute,AdminDs160Route: AdminDs160Route,AdminInboxRoute: AdminInboxRoute,AdminIncompleteCheckoutsRoute: AdminIncompleteCheckoutsRoute,AdminIntakeRoute: AdminIntakeRoute,AdminInterviewPriorityRoute: AdminInterviewPriorityRoute,AdminInterviewTrackRoute: AdminInterviewTrackRoute,AdminLeadsRoute: AdminLeadsRoute,AdminLiveSessionsRoute: AdminLiveSessionsRoute,AdminLogsRoute: AdminLogsRoute,AdminMeetingsRoute: AdminMeetingsRoute,AdminMockSchedulingRoute: AdminMockSchedulingRoute,AdminMonthlyEnrollmentsRoute: AdminMonthlyEnrollmentsRoute,AdminPaymentsRoute: AdminPaymentsRoute,AdminPendingPaymentsRoute: AdminPendingPaymentsRoute,AdminSessionsRoute: AdminSessionsRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSignupsRoute: AdminSignupsRoute,AdminSocialPreviewRoute: AdminSocialPreviewRoute,AdminStudentsRoute: AdminStudentsRoute,AdminTestingRoute: AdminTestingRoute,AdminUnsubscribeRoute: AdminUnsubscribeRoute,AdminUploadExperienceRoute: AdminUploadExperienceRoute,AdminVisaAssessmentsRoute: AdminVisaAssessmentsRoute,AdminVisaTestersRoute: AdminVisaTestersRoute,ReceiptIdRoute: ReceiptIdRoute,ResourcesSlugRoute: ResourcesSlugRoute,ResourcesF1VisaGuideRoute: ResourcesF1VisaGuideRoute,ResourcesFresherGuideRoute: ResourcesFresherGuideRoute,AdminIndexRoute: AdminIndexRoute,ResourcesIndexRoute: ResourcesIndexRoute,AdminCohortsFall2026Route: AdminCohortsFall2026Route,AdminCohortsFall2027Route: AdminCohortsFall2027Route,AdminCohortsSpring2027Route: AdminCohortsSpring2027Route
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)